module.exports = __webpack_public_path__ + "img/icon6.622b9b96.png";